import React, { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { useStores } from '../../cls/stores/MobXProvider'
/**
 * TokenCountdown component displays a live-updating countdown timer
 * for the user's authentication token expiration.
 *
 * @component
 * @param {Object} props
 * @param {boolean} [props.showLabels=true]
 *   Whether to display unit labels ("h", "m", "s") after hours, minutes, and seconds.
 * @returns {JSX.Element|null} The rendered countdown string or null if no countdown is available.
 */
const TokenCountdown = observer(({ showLabels = true }) => {
	const { users } = useStores()

	useEffect(() => {
		// Ensure the countdown starts when the component mounts
		users.startTokenCountdown()
	}, [users])

	const countdown = users.tokenCountdown
	if (!countdown) return null

	const [hours, minutes, seconds] = countdown
		.split(':')
		.map((part) => part.replace(/[a-z]/g, ''))

	return (
		<div className="we-token-count">
			{hours}
			{showLabels ? 'h' : ''}:{minutes}
			{showLabels ? 'm' : ''}:{seconds}
			{showLabels ? 's' : ''}
		</div>
	)
})

export default TokenCountdown
